module.exports = __webpack_public_path__ + "img/icon-generic-generic2.b06321a2.svg";